import { selectAllExtraInfo } from '../../selectors';
import type { RootState } from '../../store';
import getAnalytics from './getSlices/getAnalytics';
import { getAppDetails } from './getSlices/getAppDetails';
import getBusinessDetails from './getSlices/getBusinessDetails';
import getCoverDetails from './getSlices/getCoverDetails';
import getDeclines from './getSlices/getDeclines';
import getExtraInfo from './getSlices/getExtraInfo';
import getPayments from './getSlices/getPayments';
import getQuote from './getSlices/getQuote';
import getSelectCovers from './getSlices/getSelectCovers';
import { AnalyticsEvent } from './types-only';

/**
 * Helper function - remove empty object injecting into the datalayer
 * @param obj {Object}
 * @returns {object}
 */
const removeEmptyDataPoint = (obj: Record<string, unknown>) => {
  Object.entries(obj).forEach(([key, value]) => {
    if (
      (typeof value === 'object' && value && Object.keys(value).length === 0) ||
      value === undefined ||
      value === null
    )
      delete obj[key]; // The object had no properties, so delete that property
  });
  return obj;
};

/**
 * mapStore maps the store to dataLayer.data object. PII data should not pass here.
 */
const mapStore = (state: RootState, standardPayload?: AnalyticsEvent) => {
  if (!state) return {};
  const businessDetails = getBusinessDetails(state.businessDetails);
  const quote = getQuote(state.quote);
  const coverDetails = getCoverDetails(state.coverDetails);
  const extraInfo = getExtraInfo(selectAllExtraInfo(state));
  const payments = getPayments(state.payments);
  const declines = getDeclines(state.decline, standardPayload);
  const selectCover = getSelectCovers(state.selectCover);
  const analytics = getAnalytics(state.analytics);
  const appDetails = getAppDetails(state.appDetails);

  const payload = removeEmptyDataPoint({
    ...businessDetails,
    ...quote,
    ...coverDetails,
    ...extraInfo,
    ...declines,
    ...payments,
    ...selectCover,
    ...analytics,
    ...appDetails,
  });
  if (window.qbeTrack?.meta) {
    window.qbeTrack.meta.dataPoints = payload;
  }
  return payload;
};

export default mapStore;
